import { SingleDonation as SingleDonationForm } from "@bgea-js/form-templates";
import "../../../../src/content/steps-to-peace-booklet/free-gospel-tract-booklet.scss";
import * as React from 'react';
export default {
  SingleDonationForm,
  React
};